import React from 'react'
import {
  IColorProps,
  ThemeAmethystColors,
  ThemeDefaultColorsEnum,
} from './types'
import { ObsidianHomeOpen } from '../../assets/images/theme_obsidian/screen_custom/homeOpen'
import { ObsidianHomeLated } from '../../assets/images/theme_obsidian/screen_custom/homeLated'
import { ObsidianHomePaided } from '../../assets/images/theme_obsidian/screen_custom/homePaided'
import { MethystHomeOpen } from '../../assets/images/theme_methyst/screen_custom/homeOpen'
import { Colors } from '../../utils/types'
import { ObsidianMethodPaymented } from '../../assets/images/theme_obsidian/screen_custom/methodPaymented'
import { MethystHomeLated } from '../../assets/images/theme_methyst/screen_custom/homeLated'
import { MethystHomePaided } from '../../assets/images/theme_methyst/screen_custom/homePaided'
import { ObsidianAuthErro } from '../../assets/images/theme_obsidian/screen_custom/authErro'
import { ThemeChoices } from '../systemTheme/types'

export const ThemeDefaultColorDisplayName: Record<
  ThemeDefaultColorsEnum,
  string
> = {
  [ThemeDefaultColorsEnum.PRIMARY_COLOR]: 'Cor Primária',
  [ThemeDefaultColorsEnum.PRIMARY_TEXT_COLOR]: 'Texto Primário',
  [ThemeDefaultColorsEnum.PRIMARY_COLOR_DARK]: 'Cor Primária Escura',
  [ThemeDefaultColorsEnum.SECONDARY_COLOR]: 'Cor Secundária',
  [ThemeDefaultColorsEnum.SECONDARY_TEXT_COLOR]: 'Texto Secundário',
  [ThemeDefaultColorsEnum.INVOICE_LATE_COLOR]: 'Cor de Fatura Atrasada',
  [ThemeDefaultColorsEnum.INVOICE_PAID_COLOR]: 'Cor de Fatura Paga',
  [ThemeDefaultColorsEnum.INVOICE_OPEN_COLOR]: 'Cor de Fatura Aberta',
  [ThemeDefaultColorsEnum.ERROR_COLOR]: 'Cor de Erro',
}

export const ThemeDefaultColorDefaultColor: Record<
  ThemeDefaultColorsEnum,
  string
> = {
  [ThemeDefaultColorsEnum.PRIMARY_COLOR]: '#274DF8',
  [ThemeDefaultColorsEnum.PRIMARY_TEXT_COLOR]: '#FFFFFF',
  [ThemeDefaultColorsEnum.PRIMARY_COLOR_DARK]: '#0D2386',
  [ThemeDefaultColorsEnum.SECONDARY_COLOR]: '#EDEDED',
  [ThemeDefaultColorsEnum.SECONDARY_TEXT_COLOR]: '#000000',
  [ThemeDefaultColorsEnum.INVOICE_LATE_COLOR]: '#FE7B53',
  [ThemeDefaultColorsEnum.INVOICE_PAID_COLOR]: '#17CF40',
  [ThemeDefaultColorsEnum.INVOICE_OPEN_COLOR]: '#274DF8',
  [ThemeDefaultColorsEnum.ERROR_COLOR]: '#F72F33',
}

export const ThemeAmethystColorDisplayName: Record<
  ThemeAmethystColors,
  string
> = {
  [ThemeAmethystColors.PRIMARY_COLOR]: 'Cor Primária',
  [ThemeAmethystColors.BRAND_COLOR]: 'Cor da Marca',
  [ThemeAmethystColors.TEXT_COLOR]: 'Cor do Texto',
  [ThemeAmethystColors.PAID_COLOR]: 'Cor de Pago',
  [ThemeAmethystColors.LATE_COLOR]: 'Cor de Atrasado',
  [ThemeAmethystColors.OPEN_COLOR]: 'Cor de Aberto',
}

export const ThemeAmethystColorDefaultColor: Record<
  ThemeAmethystColors,
  string
> = {
  [ThemeAmethystColors.PRIMARY_COLOR]: '#8300C1',
  [ThemeAmethystColors.BRAND_COLOR]: '#8300C1',
  [ThemeAmethystColors.TEXT_COLOR]: '#FCFCFD',
  [ThemeAmethystColors.PAID_COLOR]: '#00BD62',
  [ThemeAmethystColors.LATE_COLOR]: '#F72F33',
  [ThemeAmethystColors.OPEN_COLOR]: '#8300C1',
}

export const COLORS: Record<string, IColorProps[]> = {
  [ThemeChoices.THEME_ID_OBSIDIAN]: Object.entries(ThemeDefaultColorsEnum).map(
    ([, value]) => ({
      key: value,
      name: ThemeDefaultColorDisplayName[value],
      defaultColor: ThemeDefaultColorDefaultColor[value],
    })
  ),
  [ThemeChoices.THEME_ID_METHYST]: Object.entries(ThemeAmethystColors).map(
    ([, value]) => ({
      key: value,
      name: ThemeAmethystColorDisplayName[value],
      defaultColor: ThemeAmethystColorDefaultColor[value],
    })
  ),
}

export const SCREENS_THEME: Record<
  string,
  Record<string, <T>(props: Colors<T>) => React.JSX.Element>
> = {
  [ThemeChoices.THEME_ID_OBSIDIAN]: {
    default: ObsidianHomeOpen,
    [ThemeDefaultColorsEnum.INVOICE_OPEN_COLOR]: ObsidianHomeOpen,
    [ThemeDefaultColorsEnum.INVOICE_LATE_COLOR]: ObsidianHomeLated,
    [ThemeDefaultColorsEnum.INVOICE_PAID_COLOR]: ObsidianHomePaided,
    [ThemeDefaultColorsEnum.PRIMARY_COLOR_DARK]: ObsidianMethodPaymented,
    [ThemeDefaultColorsEnum.SECONDARY_COLOR]: ObsidianMethodPaymented,
    [ThemeDefaultColorsEnum.SECONDARY_TEXT_COLOR]: ObsidianMethodPaymented,
    [ThemeDefaultColorsEnum.ERROR_COLOR]: ObsidianAuthErro,
  },
  [ThemeChoices.THEME_ID_METHYST]: {
    default: MethystHomeOpen,
    [ThemeAmethystColors.OPEN_COLOR]: MethystHomeOpen,
    [ThemeAmethystColors.LATE_COLOR]: MethystHomeLated,
    [ThemeAmethystColors.PAID_COLOR]: MethystHomePaided,
  },
}
